import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: { mode: "light" },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: "#db3131", fontSize: "1.2rem" },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            backgroundColor: "var(--surface)",
            fontFamily: "var(--font-ui)",
            fontSize: "13px",
            color: "var(--ink-1)",
            borderRadius: "var(--r-sm)",
          },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--line-strong)" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--ink-4)" },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--accent)",
            borderWidth: "1px",
            boxShadow: "0 0 0 3px rgba(40,68,166,0.14)",
          },
          "& .Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "var(--danger)" },
          "& .MuiFormLabel-root": {
            fontFamily: "var(--font-ui)",
            fontSize: "13px",
            color: "var(--ink-3)",
          },
          "& .MuiFormLabel-root.Mui-focused": { color: "var(--accent)" },
          "& .MuiFormLabel-root.Mui-error": { color: "var(--danger)" },
          "& .MuiFormHelperText-root": {
            fontFamily: "var(--font-ui)",
            fontSize: "11px",
            marginLeft: 2,
            color: "var(--ink-3)",
          },
          "& .MuiFormHelperText-root.Mui-error": { color: "var(--danger)" },
          "& .MuiInputBase-input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px var(--surface) inset",
            WebkitTextFillColor: "var(--ink-1)",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: "var(--surface)",
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          color: "var(--ink-1)",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "var(--surface)",
          border: "1px solid var(--line)",
          boxShadow: "var(--shadow-md)",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: "var(--surface)",
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          color: "var(--ink-1)",
          "&.Mui-selected": { backgroundColor: "var(--bg-subtle)" },
          "&:hover": { backgroundColor: "var(--bg-subtle)" },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: "var(--surface)",
          border: "1px solid var(--line)",
          boxShadow: "var(--shadow-md)",
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
        },
        option: {
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          '&[aria-selected="true"]': { backgroundColor: "var(--bg-subtle) !important" },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundColor: "white" },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { backgroundColor: "var(--surface)" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          fontFamily: "var(--font-ui)",
          fontSize: "13px",
          fontWeight: 500,
          textTransform: "none",
          borderRadius: "var(--r-sm)",
          letterSpacing: "-0.005em",
          minHeight: 32,
          padding: "6px 14px",
          boxShadow: "none",
        },
        containedPrimary: {
          background: "var(--accent)",
          color: "#fff",
          "&:hover": { background: "var(--accent-hover)" },
        },
        outlinedPrimary: {
          borderColor: "var(--line-strong)",
          color: "var(--ink-1)",
          "&:hover": { background: "var(--bg-subtle)", borderColor: "var(--ink-4)" },
        },
        textPrimary: {
          color: "var(--ink-2)",
          "&:hover": { background: "var(--bg-subtle)", color: "var(--ink-1)" },
        },
        outlinedError: {
          borderColor: "var(--line-strong)",
          color: "var(--danger)",
          "&:hover": { background: "var(--danger-bg)", borderColor: "var(--danger)" },
        },
        containedError: {
          background: "var(--danger)",
          "&:hover": { background: "#991B1B" },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "var(--ink-2)",
          "&:hover": { background: "var(--bg-subtle)" },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: "var(--font-ui)",
          fontSize: "16px",
          fontWeight: 600,
          color: "var(--ink-1)",
          padding: "16px 20px",
          borderBottom: "1px solid var(--line)",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "12px 20px",
          borderTop: "1px solid var(--line)",
          background: "var(--bg-subtle)",
          gap: 8,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: { root: { padding: "20px" } },
    },
    MuiTabs: {
      styleOverrides: {
        root: { minHeight: 36 },
        indicator: { backgroundColor: "var(--accent)" },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "var(--font-ui)",
          textTransform: "none",
          fontSize: "13px",
          fontWeight: 500,
          minHeight: 36,
          padding: "6px 14px",
        },
      },
    },
  },
});
